//      
                                                       
                                                                                     

export default (marshal              ) => () => (next          ) => (
  action        ,
)      => {
  if (action.type === 'INITIAL_PUBLISH') {
    marshal.dragging();
  }

  if (action.type === 'DROP_ANIMATE') {
    marshal.dropping(action.payload.completed.result.reason);
  }

  // this will clear any styles immediately before a reorder
  if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE') {
    marshal.resting();
  }

  next(action);
};



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/middleware/style.js